module.exports = __webpack_public_path__ + "static/media/claim.19dd9270.png";